import { useToggle } from "../../../../utils/Hooks"
import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, Skip, SwitchH2ToBodyLarge } from "../Molecules"
import { InfoCircle } from "../../atoms/Links"
import { Spacer } from "../../atoms/Atoms"
import SexChoices from "../../../../content/SexChoices"
import FLEInformationModal from "components/views/modal/FLEInformationModal"
import React, { useLayoutEffect } from "react"
import L10n from "../../../../lib/carrot-l10n"
import { TopSection } from "../TopSection"
import { getBenefitConfiguration } from "../../../../reducers/benefitConfiguration"
import { FeatureGate } from "../../../../utils/FeatureGate"
import useAboutYou from "../hooks/useAboutYou"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import { useHistory } from "react-router"
import { useSelector } from "react-redux"
import { AboutYouTopSection } from "components/carrot-plans/shared/ProgressTracker"
import { SelectButton } from "../../atoms/buttons/SelectButton"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYourPartnerSex = ({ next, previous }) => {
  const benefitConfiguration = useSelector(getBenefitConfiguration)
  const history = useHistory()
  const { wentBack, goBack } = useAboutYouFlowControls()
  const { data, updateAboutYou, hasQuestionBeenSkipped, continueLoading } = useAboutYou()
  const existingSelection = data?.partnerSex

  useLayoutEffect(() => {
    if (!wentBack && (data?.partnerSex || hasQuestionBeenSkipped("partnerSex"))) {
      history.push(next)
    }
  }, [history, wentBack, next, data?.partnerSex])

  const [showPartnerSexModal, togglePartnerSexModal] = useToggle(false)

  const onContinue = async () => {
    if (!existingSelection) {
      await updateAboutYou({ partnerSex: "skip" })
    }
    history.push(next)
  }

  const submitPartnerSex = async (sex) => {
    await updateAboutYou({ partnerSex: sex })
    history.push(next)
  }

  const skipPartnerSex = async () => {
    await updateAboutYou({ partnerSex: "skip" })
    history.push(next)
  }

  return (
    <FleLayout
      closeButton
      bottomContent={
        <FleContinueWrapper>
          <Skip onClick={skipPartnerSex} onClickOnly enabled={!continueLoading} />
          <ContinueArrow onClick={onContinue} enabled={!continueLoading} />
        </FleContinueWrapper>
      }
    >
      <AboutYouTopSection previous={previous}>
        <TopSection progressStep={3} leftOrBackArrow={<BackArrow onClick={() => goBack(previous)} />} />
      </AboutYouTopSection>
      <div className="flex flex-row items-center">
        <SwitchH2ToBodyLarge>What’s your partner’s sex?</SwitchH2ToBodyLarge>
        <FeatureGate filter={(c) => c.isLgtbqEnabled}>
          <InfoCircle onClick={togglePartnerSexModal} />
        </FeatureGate>
      </div>
      <Spacer height={3} />
      {SexChoices.filter((c) => !c.filter || c.filter(benefitConfiguration)).map(({ id, label }) => (
        <div key={id} className="flex flex-row justify-end w-100 mb1">
          <SelectButton
            disabled={continueLoading}
            outline={id === data?.partnerSex}
            type="button"
            onClick={() => submitPartnerSex(id)}
          >
            {label}
          </SelectButton>
        </div>
      ))}
      {showPartnerSexModal ? (
        <FLEInformationModal
          onClose={togglePartnerSexModal}
          header={l`fle2.aboutyourpartner.sex`}
          source={l`fle2.partnerSexFull`}
        />
      ) : null}
    </FleLayout>
  )
}

export { AboutYourPartnerSex }
